import React from 'react';

/**
 * Renderiza el bloque VersusSelector de SCAPP V2.
 *
 * @param {object} props
 * @param {object} props.v - Modelo de presentación y callbacks del panel.
 * @returns {React.ReactNode} Bloque visual sin estado local.
 */
export default function VersusSelector({
  v
}) {
  return React.createElement("div", {
    style: {
      "display": "flex",
      "flexDirection": "column",
      "gap": "1.111111vh",
      "minHeight": "0",
      "minWidth": "0"
    }
  }, (v.vsLeft || []).map((s, index110) => React.createElement(React.Fragment, {
    key: index110
  }, React.createElement("div", {
    style: {
      "flex": "1",
      "minHeight": "0",
      "background": "linear-gradient(180deg,rgba(22,40,64,0.55) 0%,rgba(12,24,42,0.55) 100%)",
      "border": "0.092593vh solid rgba(46,179,238,0.14)",
      "borderRadius": "0.925926vh",
      "boxShadow": "0 0.092593vh 0 rgba(255,255,255,0.03) inset,0 0.740741vh 2.222222vh rgba(0,0,0,0.25)",
      "padding": "1.111111vh 1.296296vh",
      "display": "flex",
      "flexDirection": "column",
      "gap": "0.925926vh",
      "borderTop": "0.185185vh solid " + s.c,
      "outline": "0.092593vh solid " + s.ol,
      "opacity": s.cardOp,
      "transition": "opacity .15s"
    }
  }, v.text("\n          "), React.createElement("div", {
    style: {
      "display": "grid",
      "gridTemplateColumns": "5.729167vw minmax(0,1fr) auto",
      "gap": "0.925926vh",
      "alignItems": "end"
    }
  }, React.createElement("label", {
    style: {
      "display": "flex",
      "flexDirection": "column",
      "gap": "0.277778vh",
      "minWidth": "0"
    }
  }, React.createElement("span", {
    style: {
      "fontSize": "0.925926vh",
      "color": "#8793a6",
      "letterSpacing": "0.06em",
      "textTransform": "uppercase"
    }
  }, v.text("Jaula")), React.createElement("select", {
    "key": s.key,
    "defaultValue": s.ci,
    "onChange": s.onCage,
    style: {
      "background": "rgba(3,10,22,0.6)",
      "border": "0.092593vh solid rgba(46,179,238,0.22)",
      "color": "#e4e9f0",
      "borderRadius": "0.555556vh",
      "padding": "0.37037vh 0.740741vh",
      "font": "1.203704vh 'IBM Plex Sans',sans-serif",
      "cursor": "pointer",
      "minWidth": "0"
    }
  }, (s.cageOpts || []).map((o, index111) => React.createElement(React.Fragment, {
    key: index111
  }, React.createElement("option", {
    "value": o.v,
    style: {
      "background": "#0e1b2e"
    }
  }, v.text(o.l)))))), React.createElement("div", {
    style: {
      "display": "flex",
      "flexDirection": "column",
      "gap": "0.277778vh",
      "minWidth": "0"
    }
  }, s.first ? React.createElement(React.Fragment, null, React.createElement("span", {
    style: {
      "fontSize": "0.925926vh",
      "color": "#8793a6",
      "letterSpacing": "0.06em",
      "textTransform": "uppercase"
    }
  }, v.text("Gráfico · todas las jaulas")), React.createElement("div", {
    style: {
      "display": "flex",
      "flexWrap": "wrap",
      "gap": "0.37037vh"
    }
  }, (v.vsChartPills || []).map((p, index112) => React.createElement(React.Fragment, {
    key: index112
  }, React.createElement("button", {
    "onClick": p.onClick,
    "title": p.title,
    style: {
      "display": "flex",
      "alignItems": "center",
      "gap": "0.555556vh",
      "height": "2.407407vh",
      "padding": "0 0.925926vh",
      "borderRadius": "1.203704vh",
      "border": "0.092593vh solid " + p.bd,
      "background": p.bg,
      "color": p.color,
      "font": p.fw + " 1.111111vh 'IBM Plex Sans',sans-serif",
      "cursor": "pointer",
      "whiteSpace": "nowrap"
    }
  }, React.createElement("span", {
    style: {
      "width": "0.364583vw",
      "height": "0.648148vh",
      "borderRadius": "50%",
      "background": p.c
    }
  }, null), v.text(p.l)))))) : null), React.createElement("div", {
    style: {
      "display": "flex",
      "flexDirection": "column",
      "alignItems": "flex-end",
      "gap": "0.185185vh"
    }
  }, React.createElement("span", {
    style: {
      "fontSize": "0.925926vh",
      "color": "#8793a6",
      "textTransform": "uppercase",
      "letterSpacing": "0.06em"
    }
  }, v.text(s.sumL)), React.createElement("span", {
    style: {
      "font": "600 1.481481vh 'IBM Plex Mono',monospace",
      "color": s.c,
      "whiteSpace": "nowrap"
    }
  }, v.text(s.sum)))), v.text("\n          "), React.createElement("div", {
    style: {
      "fontSize": "1.203704vh",
      "color": "#b8c1ce",
      "display": "flex",
      "alignItems": "center",
      "gap": "0.740741vh"
    }
  }, React.createElement("span", {
    style: {
      "width": "0.520833vw",
      "height": "0.925926vh",
      "borderRadius": "0.185185vh",
      "background": s.c
    }
  }, null), React.createElement("span", {
    style: {
      "fontWeight": "600",
      "color": "#e4e9f0"
    }
  }, v.text(s.name)), React.createElement("span", {
    style: {
      "color": "#8793a6"
    }
  }, v.text("· " + s.title))), v.text("\n          "), React.createElement("div", {
    style: {
      "flex": "1",
      "minHeight": "0",
      "position": "relative",
      "marginLeft": "1.770833vw",
      "marginBottom": "1.666667vh"
    }
  }, v.text("\n            "), (s.yt || []).map((y, index113) => React.createElement(React.Fragment, {
    key: index113
  }, React.createElement("div", {
    style: {
      "position": "absolute",
      "left": "0",
      "right": "0",
      "top": y.top,
      "borderTop": "0.092593vh solid rgba(135,147,166,0.12)"
    }
  }, null), React.createElement("span", {
    style: {
      "position": "absolute",
      "right": "calc(100% + 0.3125vw)",
      "top": y.top,
      "transform": "translateY(-50%)",
      "font": "0.925926vh 'IBM Plex Mono',monospace",
      "color": "#8793a6"
    }
  }, v.text(y.lab)))), v.text("\n            "), React.createElement("svg", {
    "viewBox": "0 0 600 100",
    "preserveAspectRatio": "none",
    style: {
      "position": "absolute",
      "inset": "0",
      "width": "100%",
      "height": "100%",
      "display": "block",
      "overflow": "visible"
    }
  }, React.createElement("path", {
    "d": s.bars,
    "fill": s.c,
    "opacity": "0.85"
  }, null), React.createElement("path", {
    "d": s.ay,
    "fill": "#3a4558"
  }, null), React.createElement("path", {
    "d": s.hb,
    "fill": "#fff",
    "opacity": "0.9"
  }, null), React.createElement("path", {
    "d": s.ref,
    "stroke": "oklch(0.7 0.17 45)",
    "strokeWidth": "1.5",
    "strokeDasharray": "5 4",
    "fill": "none",
    "vectorEffect": "non-scaling-stroke"
  }, null)), v.text("\n            "), s.showRef ? React.createElement(React.Fragment, null, React.createElement("span", {
    style: {
      "position": "absolute",
      "right": "0",
      "top": s.refTop,
      "transform": "translateY(-50%)",
      "background": "oklch(0.62 0.18 42)",
      "color": "#fff",
      "font": "600 0.925926vh 'IBM Plex Mono',monospace",
      "padding": "0.092593vh 0.462963vh",
      "borderRadius": "0.277778vh"
    }
  }, v.text("100"))) : null, v.text("\n            "), s.cur ? React.createElement(React.Fragment, null, React.createElement("div", {
    style: {
      "position": "absolute",
      "top": "0",
      "bottom": "0",
      "left": s.curL,
      "width": "0.052083vw",
      "background": "rgba(228,233,240,0.6)",
      "pointerEvents": "none"
    }
  }, null), React.createElement("div", {
    style: {
      "position": "absolute",
      "top": "0.185185vh",
      "left": s.curL,
      "transform": s.tipTx,
      "background": "rgba(6,14,28,0.95)",
      "border": "0.092593vh solid " + s.c,
      "borderRadius": "0.462963vh",
      "padding": "0.277778vh 0.740741vh",
      "font": "600 1.111111vh 'IBM Plex Mono',monospace",
      "color": "#e4e9f0",
      "whiteSpace": "nowrap",
      "pointerEvents": "none",
      "zIndex": "5"
    }
  }, v.text(s.tip))) : null, React.createElement("div", {
    "onMouseLeave": s.leave,
    style: {
      "position": "absolute",
      "inset": "0",
      "display": "flex",
      "zIndex": "4"
    }
  }, (s.hits || []).map((h, index114) => React.createElement(React.Fragment, {
    key: index114
  }, React.createElement("div", {
    "onMouseEnter": h.enter,
    style: {
      "flex": "1",
      "minWidth": "0",
      "cursor": "crosshair"
    }
  }, null)))), (s.xt || []).map((x, index115) => React.createElement(React.Fragment, {
    key: index115
  }, React.createElement("span", {
    style: {
      "position": "absolute",
      "top": "calc(100% + 0.37037vh)",
      "left": x.left,
      "transform": "translateX(-50%)",
      "font": "0.925926vh 'IBM Plex Mono',monospace",
      "color": "#8793a6",
      "whiteSpace": "nowrap"
    }
  }, v.text(x.lab)))), v.text("\n          ")), v.text("\n        ")))));
}
